export const makeCookieObj = () => {
    const cookies = document.cookie.split(';');
    const cookieObj = {};
    cookies.forEach((cookie) => {
        const [key, value] = cookie.split('=');
        cookieObj[key.trim()] = value;
    });
    return cookieObj;
}